import { createContext } from 'react';

import type { ComponentResponse } from '../types';

type ComponentContextValue = {
  component: ComponentResponse;
};

const ComponentContext = createContext<ComponentContextValue>(
  {} as ComponentContextValue
);

export { ComponentContext };
